import React from "react";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Grid,
  Paper,
  FormHelperText,
} from "@material-ui/core";
import DatePickerTDSAT from "features/Tdsat/components/DatePickerTDSAT";
import {
  getMainCaseByCaseNumber,
  retrieveApplicationEaMa,
} from "features/Tdsat/API/TdsatApi";
import { useSnackbar } from "contexts/SnackbarContext";
import { TDSAT_DROPDOWN_DATES } from "app/constants";
import CaseTypeInput from "features/Tdsat/components/CaseTypeInput";
import ReferenceCase from "../CaseListing/ReferenceCase";

const OrderNoticeForm = ({
  classes,
  formData,
  setFormData,
  handleInputChange,
  searchMainCaseResponse,
  setSearchMainCaseResponse,
  errors,
  setErrors,
  noticeType,
}) => {
  const { showSnackbar } = useSnackbar();

  const handleGoClick = async () => {
    let hasError = false;
    let newErrors = { case_number: "", year: "", case_type: "" };

    if (!formData.case_number) {
      newErrors.case_number = "Case Number is required";
      hasError = true;
    }

    if (!formData.year || formData.year === "Select") {
      newErrors.year = "Year is required";
      hasError = true;
    }

    if (!formData.case_type) {
      newErrors.case_type = "Case Type is required";
      hasError = true;
    }

    setErrors(newErrors);
    if (!hasError) {
      try {
        const { case_number, year, case_type } = formData;
        let response;
        if (noticeType == "ea/ma/other") {
          response = await retrieveApplicationEaMa(
            case_number,
            year,
            case_type,
						'notice',
          );
        } else {
          response = await getMainCaseByCaseNumber(
            case_number,
            year,
            case_type,
						'notice',
          );
        }
        setSearchMainCaseResponse(response?.data);
        if (response?.data) {
          showSnackbar("Searched Successfully", "success");
        }
      } catch (error) {
        console.log(error, "error");
        if (error?.response?.status === 400) {
          showSnackbar(error?.response?.data?.error, "error");
        }
      }
    }
  };

  const handleDateInput = (value) => {
    setFormData((prevData) => ({
      ...prevData,
      order_date: value,
    }));
  };

  return (
    <>
      <Paper className={classes.paper}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <TextField
                  label={"Case Number"}
                  name="case_number"
                  fullWidth
                  required
                  margin="none"
                  variant="outlined"
                  value={formData?.case_number || ""}
                  onChange={handleInputChange}
                  error={!!errors.case_number}
                  helperText={errors.case_number}
                />
              </Grid>
              <Grid item xs={6}>
                <FormControl
                  required
                  fullWidth
                  margin="none"
                  variant="outlined"
                >
                  <InputLabel>{"Year"}</InputLabel>
                  <Select
                    label={"Year"}
                    name="year"
                    value={formData.year || ""}
                    onChange={handleInputChange}
                  >
                    {TDSAT_DROPDOWN_DATES.map((option, index) => (
                      <MenuItem key={index} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.year && (
                    <FormHelperText error>{errors.year}</FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <CaseTypeInput
                  name="case_type"
                  isRequired={true}
                  caseType={formData?.case_type || ""}
                  onChange={handleInputChange}
                  label="Case Type"
                  error={errors?.case_type}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            display: "flex",
            justifyContent: "flex-start",
            marginTop: 18,
          }}
        >
          <Button
            variant="contained"
            color="primary"
            fullWidth
            className={classes.button}
            onClick={() => handleGoClick(formData)}
          >
            Search
          </Button>
        </Grid>
        <Typography className={classes.titleHeader}>
          {searchMainCaseResponse?.name || " "}
        </Typography>
      </Paper>

      {(Object.keys(searchMainCaseResponse).length !== 0) && (
				<ReferenceCase classes={classes} searchResponse={searchMainCaseResponse} isActionsRequired={false} setFormData={setFormData}/>
			)}

      <Paper className={classes.paper}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormControl
                  required
                  fullWidth
                  margin="none"
                  variant="outlined"
                >
                  <DatePickerTDSAT
                    date={formData.order_date}
                    setDate={handleDateInput}
                    label={"Order Date"}
                    isRequired={true}
                  />
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      <Paper className={classes.paper}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid
              container
              spacing={2}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid item xs={6} className={classes.titleForHeadings}>
                Send Order for Applicant(s):
              </Grid>
              <Grid item xs={6}>
                <FormControl
                  className={classes.formControl}
                  fullWidth
                  required
                  margin="none"
                  variant="outlined"
                >
                  <InputLabel>Applicants</InputLabel>
                  <Select
                    name="send_applicant"
                    value={formData.send_applicant}
                    onChange={handleInputChange}
                    label="Applicants"
                  >
                    <MenuItem value="true">YES</MenuItem>
                    <MenuItem value="false">NO</MenuItem>
                  </Select>
                  {errors.send_applicant && (
                    <FormHelperText error>
                      {errors.send_applicant}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      <Paper className={classes.paper}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid
              container
              spacing={2}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid item xs={6} className={classes.titleForHeadings}>
                Send Order for Respondent(s):
              </Grid>
              <Grid item xs={6}>
                <FormControl
                  className={classes.formControl}
                  fullWidth
                  required
                  margin="none"
                  variant="outlined"
                >
                  <InputLabel>Main Respondents</InputLabel>
                  <Select
                    name="send_respondents"
                    value={formData.send_respondents}
                    onChange={handleInputChange}
                    label="Main Respondents"
                  >
                    <MenuItem value="true">YES</MenuItem>
                    <MenuItem value="false">NO</MenuItem>
                  </Select>
                  {errors.send_respondents && (
                    <FormHelperText error>
                      {errors.send_respondents}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
      <Paper className={classes.paper}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid
              container
              spacing={2}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid item xs={6} className={classes.titleForHeadings}>
                Send Order for Applicant's Advocate:
              </Grid>
              <Grid item xs={6}>
                <FormControl
                  className={classes.formControl}
                  fullWidth
                  required
                  margin="none"
                  variant="outlined"
                >
                  <InputLabel>Main Advocate</InputLabel>
                  <Select
                    name="send_applicant_advocate"
                    value={formData.send_applicant_advocate}
                    onChange={handleInputChange}
                    label="Main Advocate"
                  >
                    <MenuItem value="true">YES</MenuItem>
                    <MenuItem value="false">NO</MenuItem>
                  </Select>
                  {errors.send_applicant_advocate && (
                    <FormHelperText error>
                      {errors.send_applicant_advocate}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </>
  );
};

export default OrderNoticeForm;
